import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import DistanceSlider from '../../components/DistanceSlider';

const SearchFormFiltersDistance = ({ distance, submitRef }) => {
  const [val, setVal] = useState(distance || 150);

  return (
    <div className="dropdown filtering-btn">
      <button className="btn btn-mod btn-border btn-circle dropdown-toggle price btn-custom-mod" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
        Distance
        <span className="caret"></span>
      </button>
      <ul id="distance-panel" className="filter-dropdown-menu dropdown-menu" aria-labelledby="dropdownMenu1">
        <div className="distance-container" style={{ padding: "15px" }}>
          <Form.Control name="distance" value={val} onChange={(e) => { }} style={{ display: 'none' }} />
          <label className="distance" htmlFor="distance">Within Distance</label>
          <DistanceSlider
            MIN={50}
            MAX={300}
            STEP={50}
            values={[val]}
            setVal={setVal}
          />
          <div className="filter-distance">
            <a href="#" onClick={e => submitRef.current.click()} style={{ color: "#1594b4", backgroundColor: "#fff" }}>Apply Filter</a>
          </div>
        </div>
      </ul>
    </div>
  );
}

export default SearchFormFiltersDistance;